import React from 'react'
import { DatePicker, FormItem } from 'formik-antd'
import { useFormikContext } from 'formik'
import { EmployeeFormData } from '../../../../services/api/employees'
import moment from 'moment'

const DATE_FORMAT = 'DD.MM.YYYY'
type Props = {
  value: moment.Moment | null
  setValue: (value: moment.Moment | null) => void
}

export const BirthdateSelect: React.FunctionComponent<Props> = ({
  value,
  setValue,
}) => {
  const { setFieldValue } = useFormikContext<EmployeeFormData>()

  const handleChange = (date: moment.Moment | null, dateString: string) => {
    setFieldValue('birthdate', dateString)
    setValue(date)
  }

  return (
    <FormItem name="birthdate" label="Дата рождения" required>
      <DatePicker
        allowClear
        style={{ width: '100%' }}
        value={value}
        name="birthdate"
        mode="date"
        format={DATE_FORMAT}
        placeholder="Дата рождения"
        onChange={handleChange}
      />
    </FormItem>
  )
}
